import { LeadEmailForm } from 'common/module/lead/email/form';
import { LeadEmailFormFactory } from 'common/module/lead/email/form.factory';
import { LeadEmailFormStrategyPropertyFactory } from 'common/module/lead/email/form/strategy/property.factory';
import { LeadEmailFormViewStoreFactory } from 'common/module/lead/email/form/view-store.factory';
import { PreactView } from 'common/module/preact/view';
import { LeadEmailFormTemplate } from 'desktop/module/lead/email/form/template';

export function LeadEmailFormPropertyFactory(): LeadEmailForm {
  const leadEmailForm = LeadEmailFormFactory();

  // Set view adapter
  leadEmailForm.setViewAdapter(
    new PreactView(LeadEmailFormTemplate, LeadEmailFormViewStoreFactory(), {
      isAutoRenderDisabled: true,
    })
  );

  // Set form strategy
  leadEmailForm.setFormStrategy(LeadEmailFormStrategyPropertyFactory());

  return leadEmailForm;
}
